import {
  Typography,
} from "antd";
import "assets/fonticons/style.css";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import K from "utilities/constants";
import { usePageFilter } from "hooks/usePageFilters";
import {  selectUserId } from "redux/slices/userSlice";
import { useSelector } from "react-redux";
import { Columns } from "./columns";
import Invoice from "redux/models/invoice";
import { ServerSideDataGrid } from "common/components/serverSideDataGrid/serverSideDataGrid";
import { DataTableLayout } from "common/components/dataTableLayout/dataTableLayout";

const {
  Invoice: { Type },
} = K;


export default function InvoiceJobBills({
  gridRef,
  billModalPrepare,
}) {
  const { id } = useParams();

  const userId = useSelector(selectUserId);

  const [search, setSearch] = usePageFilter(`invoice_bills_search`);

  const onRow = (event) => {
    billModalPrepare(event.data);
  };

  const getServerSideData = useCallback(
    (options) => {
      const params = {
        ...options,
        search: search ?? undefined,
      };

      return  Invoice.v2.getJobBills(id, params);
    },
    [id, search],
  );

  return (
    <DataTableLayout
      searchDefaultValue={search}
      onSearchChange={setSearch}
    >
      <ServerSideDataGrid
        ref={gridRef}
        configKey={K.AgGridTable.Keys.InvoiceJobDetailsColumn}
        userId={userId}
        getData={getServerSideData}
        defaultColumnConfig={Columns}
        pagination
        paginationPageSize={25}
        cacheBlockSize={25}
        rowStyle={{ cursor: "pointer" }}
        onRowClicked={onRow}
      />
    </DataTableLayout>
  );
}
